import { Link } from "react-router-dom";
import { RouterMap } from "~@/config/routes";
import { ReactComponent as Logo } from "~@/assets/images/logo-text.svg";
import clsx from "clsx";
import Styles from "./styles.module.css";
const Asider = () => {
  return (
    <aside className="flex flex-col w-full h-screen">
      <Link className="py-[17px] px-[20px]" to={RouterMap.PRODUCT.path}>
        <div style={{ width: "86px", height: "18px", marginLeft: "-4px" }}>
          <Logo />
        </div>
      </Link>
      <div className={clsx("flex-1 flex flex-col overflow-auto", Styles.aside)}>
        {Object.entries(RouterMap)
          .filter(([key, value]) => !["LOGIN", "ERROR"].includes(key))
          .map(([key, value]) => value)
          .filter((item) => item?.label)
          .map((item, index) => (
            <Link
              className={clsx(
                "py-[17px] px-[20px]",
                window.location.pathname === item.path
                  ? "bg-[#3673d8]"
                  : undefined
              )}
              key={index}
              to={item.path}
            >
              {item?.label}
            </Link>
          ))}
      </div>
    </aside>
  );
};

export default Asider;
